import React, { Fragment } from 'react';

const NativeAppFeatureListShutterbug = () => {
  return (
    <Fragment>
      <li>
        Create your own albums &amp; upload photos from DSLR, camera roll, or
        cloud.
      </li>
      <li>
        Let Waldo seamlessly deliver your photos to family &amp; friends via
        iOS, Android, and Web.
      </li>
      <li>Post &amp; download your favorite pics in hi-res.</li>
      <li>Create and send Waldograms featuring your photos.</li>
      <li>Order prints delivered directly to your home.</li>
    </Fragment>
  );
};

export default NativeAppFeatureListShutterbug;
